import React, { FC } from "react";
import classNames from "classnames";
import loadable from "@loadable/component";
import { GatsbyImage } from "gatsby-plugin-image";
import { getGatsbyImage } from "gatsby-plugin-storyblok-image";
import { ContentAlign } from "@app/components/base-page/enums";
import { Asset } from "@app/components/base-page/models";
import { FileType, checkFileType } from "@app/helpers/check-file-type";
import { MediaContentType } from "./../../enums";

const ReactPlayer = loadable(() => import("react-player"));

type Props = {
  image: Asset;
  imageSide: ContentAlign;
  mediaContentType?: MediaContentType;
};

export const MediaBlock: FC<Props> = ({
  image,
  imageSide,
  mediaContentType,
}) => (
  <div
    className={classNames("w-full", "lg:w-auto lg:grow lg:basis-1/2", {
      "lg:order-last": imageSide === ContentAlign.RIGHT,
    })}
  >
    {mediaContentType === MediaContentType.SPOTIFY ? (
      <iframe
        style={{ borderRadius: "12px" }}
        src="https://open.spotify.com/embed/playlist/2Hozc77OI66P5bhXhZioce?utm_source=generator"
        width="100%"
        height="378px"
        frameBorder="0"
        allowFullScreen
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
      ></iframe>
    ) : checkFileType(image.filename) === FileType.VIDEO ? (
      <ReactPlayer
        className="[&>video]:rounded-lg"
        url={image.filename}
        width="100%"
        height="auto"
        playing
        muted
        loop
        playsinline
        config={{
          file: {
            attributes: { disablePictureInPicture: true },
          },
        }}
      />
    ) : (
      <GatsbyImage
        image={getGatsbyImage(image.filename, { layout: "fullWidth" })}
        alt={image.alt}
        className={classNames("w-full rounded-lg")}
      />
    )}
  </div>
);
